import {
    NavController,
    NavParams,
    App,
    ModalController,
    ViewController,
    ToastController,
  } from "ionic-angular";
  import { Storage } from "@ionic/storage";
  import { Component, OnInit, Input } from "@angular/core";
  
  import { AuthProvider } from "../../../../providers/auth/auth";
  import { EmployeeRhProvider } from "../../../../providers/employeerh/employeerh";
import { RhGoalsCreateList } from "./goals-create-list/goals-create-list";
import { GoalRhProvider } from "../../../../providers/goals/goals";
import { RhGoalsAssignList } from "./goals-assign-list/goals-assign-list";
  
  @Component({
    selector: "page-rh-goals",
    templateUrl: "rh-goals.html",
  })
  export class RhGoalsPage implements OnInit {
    skills: any = null;
    answers: any = {};
    userGoals: any = null;
    isUserManager:boolean = false;
  
    constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public storageProvider: Storage,
      public app: App,
      public authProvider: AuthProvider,
      public employeeRhProvider: EmployeeRhProvider,
      public viewCtrl: ViewController,
      public toastCtrl: ToastController,
      public modalCtrl: ModalController,
      private goalRhProvider: GoalRhProvider
    ) {
      this.isUserManager = this.navParams.get('isUserManager');
    }
  
    ngOnInit() {
      this.loadDatas();
    }
  
    loadDatas() {
      this.goalRhProvider.getUserGoals().subscribe((res) => {
        if(res.success){
          this.userGoals = res.data;
        }
      })
    }

    goToCreateGoalsList(){
      let modalView = this.modalCtrl.create(RhGoalsCreateList, {}, {
        cssClass: 'my-popover'
      });
      modalView.onDidDismiss(() => {
        this.loadDatas()
      })
      modalView.present().then(() => {});
    }

    goToAssignGoalsList(){
      let modalView = this.modalCtrl.create(RhGoalsAssignList, {}, {
        cssClass: 'my-popover'
      });
      modalView.onDidDismiss(() => {
        this.loadDatas()
      })
      modalView.present().then(() => {});
    }
  
    // Modal ctrl
    dismiss() {
      this.viewCtrl.dismiss();
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-goals/rh-goals.ts